import { Button, Paper, Typography } from '@material-ui/core';
import React from 'react';

import { logUiErrorStaging } from '~/src/dash/apiV2/logUiError';
import { getApiDomain, getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';
import { logout } from '~/src/dash/router/routes';
import { IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { BaseClass } from '~/src/dash/views/base-view';
import { ErrorObject } from '~/src/dash/views/error-boundary';
import { LoadingView } from '~/src/dash/views/loading-view';

interface IProps extends IWithStylesProps {
  updateConsoleDown: VoidFunction;
  hasUiError: boolean;
  errorObject: ErrorObject;
}

interface IState {
  pageLoading: boolean;
  logErrorForStgClicked: boolean;
}

export const AppErrorView = decorate(
  {
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginTop: 0,
        marginRight: 'auto',
        marginLeft: 'auto',
        maxWidth: '450px',
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      pageLoading: true,
      logErrorForStgClicked: false,
    };

    componentDidMount() {
      fetch(getApiDomain() + '/versionz').then(
        () => {
          this.setState({
            pageLoading: false,
          });
        },
        () => {
          fetch(getApiDomain() + '/versionz').then(() => {
            this.setState({
              pageLoading: false,
            });
          }, this.props.updateConsoleDown);
        },
      );
    }

    logErrorForStaging(error: ErrorObject) {
      logUiErrorStaging(error);
      this.setState({
        logErrorForStgClicked: true,
      });
    }

    render = () => {
      const { classes, hasUiError, errorObject } = this.props;

      if (this.state.pageLoading) {
        return <LoadingView active={true} text='Loading' />;
      }
      const isStaging = window.location.hostname.substring(0, 2) === 'z0';

      return (
        <div
          style={{
            width: '100%',
            height: '100vh',
            backgroundColor: getColorTheme('signInBackground'),
            margin: '0px 0px 0px 0px',
          }}
        >
          <div style={{ height: '100px' }} />
          <BaseClass id='error'>
            <Paper
              classes={{
                root: classes.paper,
              }}
            >
              <Typography variant='h6' gutterBottom>
                Error
              </Typography>
              {hasUiError ? (
                <>
                  <Typography variant='body1' gutterBottom>
                    We apologize, there seemed to be an error loading the page.
                  </Typography>
                  <Button
                    variant='contained'
                    onClick={window.location.reload.bind(window.location)}
                  >
                    Return to the Previous Page
                  </Button>
                  {isStaging && (
                    <Button
                      variant='contained'
                      onClick={() => this.logErrorForStaging(errorObject)}
                      disabled={this.state.logErrorForStgClicked}
                      style={{ marginTop: '10px' }}
                    >
                      Log this error to #ui-errors
                    </Button>
                  )}
                </>
              ) : (
                <>
                  <Typography variant='body1' gutterBottom>
                    We apologize, there seemed to be an error loading the route.
                  </Typography>
                  <Button variant='contained' onClick={logout}>
                    Return to Signin
                  </Button>
                </>
              )}
            </Paper>
          </BaseClass>
        </div>
      );
    };
  },
);
